import { FC } from 'react';
import { NotificationTypes, notificationTypesReadable } from '@dynamika-shared/types/subscription';
import { notificationTypesDescriptions } from '../constants';
import { PlusIcon } from '@dynamika-shared/ui/icons';

export type NotificationTypeHeaderProps = {
  notificationType: NotificationTypes;
  onAddSubscription: () => void;
};

export const NotificationTypeHeader: FC<NotificationTypeHeaderProps> = ({
  notificationType,
  onAddSubscription,
}) => {
  return (
    <div className='mb-3 flex flex-row justify-between items-center'>
      <div className='flex flex-col'>
        <h3 className='font-sans text-1824 font-medium text-black'>
          {notificationTypesReadable[notificationType]}
        </h3>
        <p className='font-sana text-1424 text-spanishGray'>
          List of email subscriptions of users who receive this notification.{' '}
          {notificationTypesDescriptions[notificationType]}
        </p>
      </div>
      <div className='flex justify-end'>
        <button
          onClick={onAddSubscription}
          className="bg-blackOlive border border-chineseBlack flex gap-1 items-center justify-center px-2 py-1 rounded-2xl cursor-pointer hover:opacity-90 transition-opacity"
        >
          <PlusIcon width={18} height={18} className="text-white" />
          <span className="font-inter text-1624 font-semibold text-white whitespace-nowrap">
            Subscription
          </span>
        </button>
      </div>
    </div>
  );
};
